import Lottie from "lottie-react";
import animation from "../../assets/images/contact-anim.json";

import { useTranslation } from "react-i18next";

function Legal_Disclairmer() {
  const { t } = useTranslation("global");
  return (
    <>
      <div className="clip-bottom relative bg-primary-dark text-white py-16 px-4 flex flex-col items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold">
            {t("footer.ressources")} <span className="text-secondary"></span>
          </h1>
          <p className="mt-4 max-w-2xl mx-auto"></p>
        </div>
      </div>
      <div className=" flex-row md:flex-row mt-10 p-8">
        <div className="md:w-1/2 text-left p-6">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">
            {t("mention.1")}
          </h2>
          <p className="text-lg text-gray-700 mb-4">**************</p>
        </div>
        <div className="md:w-1/2 text-left p-6">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">Contact</h2>
          <p className="text-lg text-gray-700 mb-4">**************</p>
        </div>
        <div className="md:w-1/2 text-left p-6">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">
            {t("mention.2")}
          </h2>
          <p className="text-lg text-gray-700 mb-4">**************</p>
        </div>

        <div className="md:w-1/2 text-left p-6">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">
            {t("mention.3")}
          </h2>
          <p className="text-lg text-gray-700 mb-4">OVH</p>
        </div>
      </div>
    </>
  );
}

export default Legal_Disclairmer;
